import React from "react";

const TrashIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.66 14.56" width="16" height="16" fill="none" >
        <polyline stroke="black" points="2.63 3.17 3.63 14.06 10.29 14.06 11.29 3.34"/>
        <line stroke="black" y1="2.99" x2="13.66" y2="2.99"/>
        <polyline stroke="black" points="4.7 2.57 4.7 0.5 9.33 0.5 9.33 2.62"/>
    </svg>
);

export default TrashIcon;
